import { connect } from 'react-redux';
import { updateAnnouncement } from '@chegg-tutors-chat/shared/redux/modules/announcement/actions';
import HCVInfoBanner, { HCV_INFO_TEXT } from './HCVInfoBanner';

const mapDispatchToProps = {
  updateAnnouncement: () => updateAnnouncement({ announcement: HCV_INFO_TEXT })
};

export default connect(null, mapDispatchToProps)(HCVInfoBanner);
